/**
 * Created by Alex Aguilar on 6/23/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('baseRateService', baseRateService)

    baseRateService.$inject = ['$http', 'CONFIG','messageService'];

    function baseRateService($http, CONFIG,messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/baseRate';

        var service = {
            getBaseRates: getBaseRates,
            saveBaseRate: saveBaseRate,
            getBaseRate: getBaseRate,
            getBaseRateByOriginDestiny: getBaseRateByOriginDestiny,
            updateBaseRate: updateBaseRate,
            deleteBaseRate: deleteBaseRate,
            getBaseRateByCustomerCorporate: getBaseRateByCustomerCorporate
        };

        return service;

        function getBaseRates(page, size){
            return $http.get(urlBase + '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('')
                });
        }

        function saveBaseRate(baseRate){
            return $http.post(urlBase, baseRate)
        }

        function getBaseRate(id){
            return $http.get(urlBase + "/" +id)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.registerErrorFind('baseRates');
                })
        }

        function getBaseRateByOriginDestiny(airportOriginId, airportDestinyId){
            return $http.get(urlBase + "/search/" + airportOriginId + "/" + airportDestinyId)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.registerErrorFind('baseRates');
                })
        }

        function updateBaseRate(id, baseRate, nameRoute){
            return $http.put(urlBase + "/" + id, baseRate)
                .then(function(){
                    messageService.registerUpdate(nameRoute);
                }, function(){
                    messageService.registerUpdateError(nameRoute);
                });
        }

        function deleteBaseRate(id){
            return $http.delete(urlBase + "/" + id)
        }

        function getBaseRateByCustomerCorporate(page, size, customerCorporateId){
            return $http.get(urlBase +'/byCustomerCorporate/'+customerCorporateId+ '?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('')
                });
        }
    }
})();
